import { PageSize } from '@/constant';
import { GetWorkerUseTipListParams } from '@/services';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IPayloadGetWorkerUseTipDetailRequest,
	IPayloadGetWorkerUseTipDetailSuccess,
	IPayloadGetWorkerUseTipListRequest,
	IPayloadGetWorkerUseTipListSuccess,
	IWorkerUseTipDetailStore,
} from './worker-use-tip.type';

const InitParams: GetWorkerUseTipListParams = {
	page: 1,
	pageSize: PageSize.S,
	searchTypes: [],
};

const initialState = {
	fetching: false,
	list: [] as IWorkerUseTipDetailStore[],
	total: 0,
	params: InitParams,
	detail: {} as IWorkerUseTipDetailStore,
};

const workerUseTipSlice = createSlice({
	initialState,
	name: 'workerUseTip',
	reducers: {
		/**---- GET COMMON NOTICE LIST START ---- */
		getWorkerUseTipListRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerUseTipListRequest>
		) => {
			return {
				...state,
				fetching: true,
				params: action?.payload,
			};
		},
		getWorkerUseTipListSuccess: (
			state,
			action: PayloadAction<IPayloadGetWorkerUseTipListSuccess>
		) => {
			const { content, total } = action.payload;
			state.fetching = false;
			state.list = content;
			state.total = total;
		},
		getWorkerUseTipListFailure: (state) => {
			state.fetching = false;
			state.total = 0;
			state.list = [];
		},
		/**---- GET COMMON NOTICE LIST END ---- */

		/**---- GET COMMON NOTICE DETAIL START ---- */
		getWorkerUseTipDetailRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerUseTipDetailRequest>
		) => {
			state.fetching = true;
		},
		getWorkerUseTipDetailSuccess: (
			state,
			action: PayloadAction<IPayloadGetWorkerUseTipDetailSuccess>
		) => {
			const { detail } = action.payload;
			state.fetching = false;
			state.detail = detail;
		},
		getWorkerUseTipDetailFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET COMMON NOTICE DETAIL END ---- */
	},
});

export const WorkerUseTipSelectors = {
	selectFetching: (state: RootState) => state.workerUseTip.fetching,
	selectParams: (state: RootState) => state.workerUseTip.params,
	selectList: (state: RootState) => state.workerUseTip.list,
	selectTotal: (state: RootState) => state.workerUseTip.total,
	selectDetail: (state: RootState) => state.workerUseTip.detail,
};

export const WorkerUseTipActions = workerUseTipSlice.actions;
export const WorkerUseTipReducer = workerUseTipSlice.reducer;
